import React from 'react'

import Layout from '../components/layout'
import LogAiPage from '../components/log-ai/LogAiPage'
import { LOG_AI_EN } from '../constants/logAiContent'

const LogAiEn = () => (
  <Layout
    lang="en"
    title={LOG_AI_EN.seo.title}
    meta={{ description: LOG_AI_EN.seo.description }}
    rootProps={{ className: 'page log-ai' }}
  >
    <LogAiPage lang="en" />
  </Layout>
)

export default LogAiEn
